export default {"src":"/_next/static/media/WPL-Title.b14871bd.svg","height":38,"width":200};